// removed by extract-text-webpack-plugin
module.exports = {"my-loading":"my-loading"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/Loading/style.less
// module id = 1605
// module chunks = 367